const ko = {};

export default ko;
